import { Type } from "./Type";

export class OsCorrespondance{
    idOsCorrespondance:number = 0
    nomOs: string = "";
    isDeleted: boolean = false;
    type?: Type
}